<template>
  <div>
    <div class="th-container chat-container" ref="chatContainer">
      <div class="chat-main">
        <div class="chat-content-left">
          <div class="chat-content-search" v-if="chats && chats.length">
            <base-input
                :input-type="'search'"
                :input-class="'w-100 search-input'"
                :placeholder="'Search username'"
                v-model="search"
                class="search-input-block"
            />
          </div>
          <div v-else class="no-messages">
            <h3>No Messages</h3>
          </div>
          <div class="chats" ref="chats">
            <template v-for="{id,username, user_id, unread_messages_count, last_message, last_date, messages_count, avatar } in filteredChats">
              <div  v-if="messages_count || chatId === id"
                  @click="changeChat(id)"
                   :key="`chat_${id}`"
                   :class="[chatId === id, chatId === id ? 'active' : '', unread_messages_count ? 'unread' : '']"
                   class="chats-item">
                <div class="chats-item-image" @click="goToProfile(username)">
                  <img v-if="avatar" :src="avatar" alt="Avatar">
                  <img v-else src="@assets/images/user-default.png" alt="#">
                  <svg v-if="checkIsOnline(user_id)" width="14" height="14" viewBox="0 0 14 14" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <circle cx="7" cy="7" r="6" fill="#20D930" stroke="white" stroke-width="2"/>
                  </svg>
                  <svg v-else width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="7" cy="7" r="6" fill="#C1C1C1" stroke="white" stroke-width="2"/>
                  </svg>
                </div>
                <div class="chats-item-text">
                  <p class="chats-item-title">{{ username }}</p>
                  <p class="chats-item-last-message" v-if="last_message.length">
                    {{ last_message.length > 20 ? last_message.slice(0, 20) + '...' : last_message }}</p>
                </div>
                <div class="chats-item-date" v-if="last_date">
                  <p>{{ last_date }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="chat-content-main"
             v-if="activeChat"
             :class="{'disable': messages}">
          <div class="chat-content-header">
            <div class="chat-content-header-left">
              <div @click="closeChat" class="chat-content-mobile-header-left">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <rect width="36" height="36" fill="url(#close-chat-svg)"/>
                  <defs>
                    <pattern id="close-chat-svg" patternContentUnits="objectBoundingBox" width="1" height="1">
                      <use xlink:href="#image0_1284_4724" transform="scale(0.005)"/>
                    </pattern>
                    <image id="image0_1284_4724" width="200" height="200" xlink:href="data:image/png;base64,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"/>
                  </defs>
                </svg>
              </div>
              <div class="chat-content-header-left-image" @click="goToProfile(activeChat.username)">
                <img v-if="activeUser?.avatar" class="avatar" :src="activeUser?.avatar" alt="avatar"/>
                <img v-else src="@assets/images/user-default.png" alt="#">
                <svg v-if="checkIsOnline(activeChat.user_id)" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7" fill="#20D930" stroke="white" stroke-width="2"/>
                </svg>
                <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7" fill="#C1C1C1" stroke="white" stroke-width="2"/>
                </svg>
              </div>
              <div class="chat-content-header-text">
                <p class="chat-content-header-text-name" @click="goToProfile(activeChat.username)">{{
                    activeChat.username
                  }}</p>
                <p class="chat-content-header-text-status" v-if="checkIsOnline(activeChat.user_id)">Online</p>
                <p class="chat-content-header-text-status" v-else>Last seen {{ activeChat.last_date ?? 'Never' }}</p>
              </div>
            </div>

            <div class="chat-content-header-right">
              <div class="more-info">
                <DotsIcon @click.prevent="dropdownOpen = !dropdownOpen" class="dots-btn"/>
                <div class="chat-dropdown" :class="dropdownOpen ? 'd-block' : 'd-none'">
                  <div class="chat-dropdown-item">
                    <p>Report</p>
                  </div>
                  <div class="chat-dropdown-item">
                    <p>Block</p>
                  </div>
                  <div class="chat-dropdown-item">
                    <p>Mute</p>
                  </div>
                  <div class="chat-dropdown-item">
                    <p class="delete-chat" @click="openDeleteChatModal">Delete</p>
                  </div>
                </div>
              </div>

              <div class="tipper-buttons" v-if="user?.role_id === 1">
                <base-button
                    class="primary"
                    @click="openChooseProductModal()"
                >
                  Send Product
                </base-button>
              </div>
              <template v-else>
                <base-button
                    class="primary"
                    @click="openChooseProductModal(activeChat.user_id)"
                >
                  Choose Product
                </base-button>
<!--                <base-button-->
<!--                    class="primary"-->
<!--                    @click="showTipRequest()"-->
<!--                >-->
<!--                  Request Tip-->
<!--                </base-button>-->
              </template>
            </div>

            <div class="chat-content-header-right mobile">
              <div class="chat-content-header-right-buttons">

                <base-button
                    class="secondary"
                    @click="showTipRequest(true)"
                    :disabled="!stripeVerified(activeUser ? false : 0)"
                >
                  Send
                </base-button>


                <base-button
                    class="primary"
                    @click="showTipRequest()"

                >
                  Request
                </base-button>


              </div>

              <DotsIcon @click.prevent="dropdownOpen = !dropdownOpen" class="dots-btn"/>

              <div class="chat-dropdown" :class="dropdownOpen ? 'd-block' : 'd-none'">
                <div class="chat-dropdown-item">
                  <p>Report</p>
                </div>
                <div class="chat-dropdown-item">
                  <p>Block</p>
                </div>
                <div class="chat-dropdown-item">
                  <p>Mute</p>
                </div>
                <div class="chat-dropdown-item">
                  <p class="delete-chat" @click="openDeleteChatModal">Delete</p>
                </div>
              </div>
            </div>

          </div>

          <div class="chat-content">
            <div class="chat-messages-main" ref="messages">
              <chat-message
                  v-if="messages && messages.length"
                  :messages="messages"
                  :receiver="activeChat"
                  :activeUser="activeUser"
                  @sendTip="openPayment($event)"
                  @rating="openRating"
              />
              <chat-message
                  v-if="newMessages && newMessages.length"
                  :messages="newMessages"
                  :receiver="activeChat"
                  :animationClass="'fade-in-animation'"
                  :activeUser="activeUser"
                  @sendTip="openPayment($event)"
                  @rating="openRating"
              />
            </div>
            <div class="chat-content-input">
              <base-text-area
                  @click="readMessages"
                  @checkenter="checkEnter($event)"
                  @input="controlTextarea()"
                  v-model="message"
                  :input-type="'text'"
                  :input-name="'message'"
                  :placeholder="'Text goes here...'"
              />
              <button @click="sendMessage()" class="chat-input-send">Send</button>
            </div>
          </div>
        </div>
        <div v-else class="select-message-block">
          <h4>Select a Message</h4>
          <p>When you have messages you’ll see them here.</p>
          <img src="@assets/images/select-message.svg" alt="Select message">
        </div>
      </div>
    </div>

    <send-amount-modal
        v-model="sendAmountDialog"
        :receiver="activeChat"
        :sended="sendTipItem"
        @send="sendRequestTip"
    />

    <base-modal
        v-if="showModalRequestTipDone"
        @close="showModalRequestTipDone = false"
        :width="'480px'"
        :height="'184px'"
    >
      <template v-slot:body>
        <div class="d-flex flex-column align-items-center modal-body-main">
          <div class="modal-body-image">
            <img v-if="activeUser?.avatar" :src="activeUser?.avatar" alt="#">
            <img v-else src="@assets/images/user-default.png" alt="#">
          </div>
          <div class="modal-body-title">
            <p>
              Request amount
            </p>
          </div>

          <div class="modal-body-tip">
            <p @click="showModalRequestTipDone = false">
              Done
            </p>
          </div>

        </div>
      </template>

    </base-modal>

    <template v-if="paymentMethodDialog && paymentMethodItem">
      <choose-payment-method
          v-model="paymentMethodDialog"
          :receiver="activeChat"
          :item="paymentMethodItem"
          @rating="openRating"
      />
    </template>

    <rating-modal
        v-model="ratingMethodDialog"
        v-if="ratingMethodDialog"
        :receiver="activeChat"
        :tip="ratingMethodItem"
    />

    <choose-product-modal
        v-model="chooseProductModalStatus"
        v-if="chooseProductModalStatus"
        @close="chooseProductModalStatus = false"
        :user="user"
        :products="chooseProductModalProducts"
        @send-product="sendProductMessage"
        @send-membership="sendMembershipMessage"
    />

    <delete-chat-confirm-modal
        v-model="deleteChatModalStatus"
        v-if="deleteChatModalStatus"
        @close="deleteChatModalStatus = false"
        @delete="deleteChat(activeChat.id)"
    />

    <WishPurchase v-if="buyModalStatus"/>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import buyProduct from "../../../mixins/buyProduct";
import currencyHelper from "../../../mixins/currencyHelper";
import BaseInput from "../../UI/BaseInput";
import BaseTextArea from "../../UI/BaseTextArea";
import BaseButton from "../../UI/BaseButton";
import BaseModal from "../../UI/BaseModal";
import ChatMessage from "./ChatMessage/ChatMessage";
import ChoosePaymentMethodModal from "../../Modals/ChoosePaymentMethodModal";
import RatingModal from "../../Modals/RatingModal";
import SendAmountModal from "../../Modals/SendAmountModal";
import ChooseProductModal from "../../Modals/ChooseProductModal";
import DeleteChatConfirmModal from "../../Modals/DeleteChatConfirmModal";
import WishPurchase from "../../Modals/BuyGift/WishPurchase.vue";
import preloader from "@/mixins/preloader";

export default {
  name: "ChatPage",
  components: {
    'base-input': BaseInput,
    'base-text-area': BaseTextArea,
    'base-button': BaseButton,
    'chat-message': ChatMessage,
    'base-modal': BaseModal,
    'choose-payment-method': ChoosePaymentMethodModal,
    'rating-modal': RatingModal,
    'send-amount-modal': SendAmountModal,
    'choose-product-modal': ChooseProductModal,
    'delete-chat-confirm-modal': DeleteChatConfirmModal,
    WishPurchase
  },
  data() {
    return {
      sendAmountDialog: false,
      paymentMethodDialog: false,
      paymentMethodItem: null,
      ratingMethodDialog: false,
      ratingMethodItem: null,
      dropdownOpen: false,
      message: null,
      chats: [],
      search: '',
      messages: null,
      chatId: null,
      userId: null,
      newMessages: [],
      showModalRequestTip: false,
      showModalRequestTipDone: false,
      sendTipItem: null,
      activeUser: null,
      requestAmount: null,
      chooseProductModalStatus: false,
      chooseProductModalProducts: [],
      deleteChatModalStatus: false
    }
  },
  mixins: [currencyHelper, buyProduct, preloader],
  computed: {
    ...mapGetters({user: 'auth/user', onlineUsers: "auth/onlineUsers", currency: "currency"}),
    activeChat() {
      return this.chats.find(i => i.id === this.chatId);
    },
    filteredChats() {
      if (!this.chats) {
        return [];
      }
      if (!this.search) {
        return this.chats;
      }

      if (typeof this.search === "string") {
        const search = this.search.toLowerCase();
        return this.chats.filter(i => i.username.toLowerCase().indexOf(search) > -1);
      }
      return this.chats;
    },
  },
  watch: {
    chatId(n, o) {
      if (o) {
        this.removeListener(o)
      }
      if (n) {
        this.addListener(n);
        this.getMessages();
      }
    },
  },
  mounted() {
    this.getChats();
    window.Echo.channel(`user-chat-${this.user.id}`).listen(".Message", (e) => {
      this.unreadMessage(e.data);
      this.lastMessage(e.data);
    });
    document.body.classList.add('chat');
    this.setLoading(false);
  },
  methods: {
    stripeVerified(verifiedStatus) {
      return (process.env.VUE_APP_PAYMENT_PROVIDER || 'centryos') === 'centryos' || verifiedStatus === 1;
    },
    openRating(e) {
      this.ratingMethodDialog = true;
      this.ratingMethodItem = e;
      this.paymentMethodDialog = false;
      this.paymentMethodItem = null;
    },
    openPayment(event) {
      this.paymentMethodDialog = true;
      this.paymentMethodItem = event;
    },
    showTipRequest(send = false) {
      this.sendAmountDialog = true;
      this.sendTipItem = send ? this.activeUser : null;
    },
    sendRequestTip(amount) {
      this.requestAmount = amount
      this.$validator.validate().then((valid) => {
        if (valid) {
          const object = {
            currency_id: this.$store.state.currency.id,
            receiver_id: this.activeUser.id,
            amount: this.requestAmount,
            chat_id: this.chatId
          };
          if (this.sendTipItem) {
            object.fee_amount = object.amount * 0.01;
            object.total = object.amount * 1.01;
            this.openPayment({send: true, object});


            this.requestAmount = null;
            this.sendAmountDialog = false;

            return;
          }

          this.axios.post(
              'tip/store', object).then((res) => {
            this.newMessages.push(res.data.tip_message);
            this.toast.info(res.data.message)
            this.$validator.reset();
            this.$nextTick(() => {
              this.requestAmount = null
              this.sendAmountDialog = false
              this.showModalRequestTipDone = true
            })
          }).catch((res) => {
            this.toast.error(res.data.message)
            this.$validator.reset();
            this.$nextTick(() => {
              this.requestAmount = null
              this.showModalRequestTip = false
            })
          })
        }
      })
    },
    changeChat(id) {
      this.chatId = id;
      this.readMessages();
      if (this.$route.path !== `/chat/${id}`) {
        this.$router.push({name: 'chat', params: {id}})
      }
      this.getActiveUser();
      if (window.innerWidth <= 820) {
        if (document.querySelector('.chat-content-left')) {
          document.querySelector('.chat-content-left').classList.add('closed')
        }
        if (document.querySelector('.chat-content-main')) {
          document.querySelector('.chat-content-main').classList.remove('d-none')
        }
      }

    },
    checkIsOnline(id) {
      return this.onlineUsers.findIndex(i => i.id === id) > -1;
    },
    scrollToBottom() {
      if (!this.chatId) {
        return false;
      }
      const chat = document.querySelector('.chat-messages-main div .chat-message:last-child');
      chat?.scrollIntoView({
        behavior: 'instant'
      })
    },
    lastMessage(data) {
      const ind = this.chats.findIndex(i => i.id === data.id);
      if (ind > -1) {
        const chat = this.chats[ind];
        chat.last_message = data.last_message || '';
        this.chats.splice(ind, 1, chat);
      }
    },
    unreadMessage(data) {
      const ind = this.chats.findIndex(i => i.id === data.id);
      if (ind > -1) {
        const chat = this.chats[ind];
        chat.unread_messages_count = data.count || 0;
        this.chats.splice(ind, 1, chat);
      } else {
        this.getChats();
      }
    },
    readMessages() {
      if (!this.activeChat.unread_messages_count) {
        return;
      }
      this.axios.post(`chat/read`, {id: this.chatId}).then(() => {
        this.unreadMessage({id: this.chatId});
        this.scrollToBottom();
      })
    },
    getChats() {
      this.axios.post(`user/chats`).then((res) => {
        res.data.sort(function (a, b) {
          return new Date(b.last_message_date) - new Date(a.last_message_date);
        });
        this.chats = res.data || [];
        const id = parseInt(this.$route.params.id);
        let chat = this.chats.find(i => i.id === id);
        if( chat ) {
          this.chatId = chat.id;
          this.getActiveUser();
        }
      })
    },
    getActiveUser() {
      this.axios.post('user/active', {id: this.activeChat.user_id})
          .then((res) => {
            this.activeUser = res.data.user
          })
    },
    removeListener(id) {
      window.Echo.channel(`room.${id}`).stopListening('.Chat');
    },
    updateMessage(data) {
      let ind = Object.values(this.messages).findIndex(i => i.id === data.id);
      if (ind > -1) {
        this.messages.splice(ind, 1, data);
        return true;
      }
      ind = this.newMessages.findIndex(i => i.id === data.id);
      if (ind > -1) {
        this.newMessages.splice(ind, 1, data);
        return true;
      }
      return false;
    },
    addListener(id) {
      window.Echo.channel(`room.${id}`).listen(".Chat", ({data}) => {
        if (data.is_update) {
          if (!this.updateMessage(data)) {
            this.newMessages.push(data);
            setTimeout(() => {
              this.scrollToBottom();
            }, 100);
          }
          return;
        }

        if (data.sender_id === this.user.id) {
          return;
        }
        this.newMessages.push(data);
        setTimeout(() => {
          this.scrollToBottom();
        }, 100);
      });
    },
    sendMessage() {
      if (this.message) {
        this.axios.post(`chat/message`,
            {
              chat_id: this.chatId,
              message: this.message
            }).then(() => {
          this.newMessages.push({
            text: this.message,
            sender_id: this.user.id
          });
          this.activeChat.last_message = (this.message.length > 20 ? this.message.slice(0, 20) + '...' : this.message);
          this.message = null;
        }).then(() => {
          this.scrollToBottom();
          this.controlTextarea();
        })
      }
    },
    controlTextarea() {
      const textarea = document.querySelector('.chat-content-input textarea');
      textarea.style.height = '1px';
      var textareaMaxHeight = 130;
      textarea.scrollHeight > 48 ? textarea.style.height = (textarea.scrollHeight <= textareaMaxHeight ? textarea.scrollHeight : textareaMaxHeight) + 'px' : textarea.style.height = '48px';

      this.axios.post(`chat/start`, { id: this.chatId })
    },
    checkEnter(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.sendMessage();
      }
    },
    getMessages() {
      this.axios.post(`chat/messages`,
          {
            id: this.chatId
          }).then(({data}) => {
        this.messages = Object.values(data);
        this.newMessages = [];
        this.unreadMessage({id: this.chatId});
        const chat = document.querySelector('.chat-content-main');
        chat.scrollTo(0, chat.scrollHeight);
        if (window.innerWidth <= 820) {
          if (document.querySelector('.chat-content-left')) {
            document.querySelector('.chat-content-left').classList.add('closed')
          }
          if (document.querySelector('.chat-content-main')) {
            document.querySelector('.chat-content-main').classList.remove('d-none')
          }
        }
        setTimeout(() => {
          this.scrollToBottom();
        }, 100);
      })
    },
    closeChat() {
      if (document.querySelector('.chat-content-left')) {
        document.querySelector('.chat-content-left').classList.remove('closed');
      }
      if (document.querySelector('.chat-content-main')) {
        document.querySelector('.chat-content-main').classList.add('d-none');
      }
      // remove active class from selected chat item in chat list sidebar on mobile view (when chat window is closed) - START //
      this.chatId = null;
      this.messages = [];
      // remove active class from selected chat item in chat list sidebar on mobile view (when chat window is closed) - END //
      setTimeout(() => {
        this.$refs.chatContainer.scrollIntoView()
      }, 300);
    },
    goToProfile(username) {
      this.$router.push({name: 'user-profile', params: {username}});
    },
    openDeleteChatModal() {
      this.deleteChatModalStatus = true
    },
    deleteChat(id) {
      this.axios.post(`chat/delete`,
          {
            id: id
          })
          .then(() => {
            this.deleteChatModalStatus = false
            this.getChats()
            this.$router.push({name: 'chat'});
          })
    },
    openChooseProductModal(id) {
      if(id) {
        this.axios.get(`user/${id}/products`).then((res) => {
          this.chooseProductModalProducts = res.data
          this.chooseProductModalStatus = true
        })
      } else {
        this.chooseProductModalProducts = this.user.content_products
        this.chooseProductModalStatus = true
      }
    },
    sendProductMessage(product) {
      this.axios.post(`chat/message`,
          {
            chat_id: this.chatId,
            message: product.name,
            object_type: 'product',
            object_id: product.id
          }).then(() => {
        this.newMessages.push({
          text: product.name,
          sender_id: this.user.id,
          product_id: product.id,
          type: 'product',
          object: product,
        });
        this.activeChat.last_message = (product.name.length > 20 ? product.name.slice(0, 20) + '...' : product.name);
        this.message = null;
      }).then(() => {
        this.scrollToBottom();
        this.controlTextarea();
        this.chooseProductModalStatus = false;
      })
    },
    sendMembershipMessage(membership) {
      this.axios.post(`chat/message`,
          {
            chat_id: this.chatId,
            message: membership.name,
            object_type: 'membership',
            object_id: membership.id
          }).then(() => {
        this.newMessages.push({
          text: membership.name,
          sender_id: this.user.id,
          product_id: membership.id,
          type: 'membership',
          object: membership,
        });
        this.activeChat.last_message = (membership.name.length > 20 ? membership.name.slice(0, 20) + '...' : membership.name);
        this.message = null;
      }).then(() => {
        this.scrollToBottom();
        this.controlTextarea();
        this.chooseProductModalStatus = false;
      })
    },
  }
}

window.onresize = () => {
  if (window.innerWidth <= 820 && document.querySelector('.chat-content-left') && document.querySelector('.chat-content-main')) {
    document.querySelector('.chat-content-left').classList.add('closed')
    document.querySelector('.chat-content-main').classList.remove('d-none')
  } else {
    if (document.querySelector('.chat-content-left')) {
      document.querySelector('.chat-content-left').classList.remove('closed')
    }
  }
};

</script>

<script setup>
import './ChatPage.scss'
import DotsIcon from '../../../assets/svg/DotsIcon.vue';
</script>
